import { render, staticRenderFns } from "./v_Ongoing_Camera.vue?vue&type=template&id=0e39a973&scoped=true&"
import script from "./v_Ongoing_Camera.vue?vue&type=script&lang=js&"
export * from "./v_Ongoing_Camera.vue?vue&type=script&lang=js&"
import style0 from "./v_Ongoing_Camera.vue?vue&type=style&index=0&id=0e39a973&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e39a973",
  null
  
)

export default component.exports